
import '../../App.css';
import React, { useRef } from 'react';
import owaa5 from '../../images/owaa5.png'
import image2 from '../../images/Owaa_Slides1.png'
import Pic1 from '../../images/Pic1.png'
import Pic2 from '../../images/Pic2.png'
import Footer from '../../components/Footer.js';
import Header from '../../components/Header';
import GoogleButton from '../../components/GoogleButton';
import AppleButton from '../../components/AppleButton';

const Home = () => {
    const feature = useRef(null);
    const gotoFeature = () => window.scrollTo({ top: feature.current.offsetTop, behaviour: "smooth" })
    return (
        <body className='font-Poppins'>
            {/* header */}
            <Header gotoFeature={gotoFeature} />

            {/* Hero */}
            <section className='relative'>
                <div className='container flex flex-col-reverse lg:flex-row items-center gap-12 mt-14 lg:mt-12'>
                    {/* content */}
                    <div className='flex flex-1 flex-col items-center lg:items-start'>
                        <h2 className='text-primary text-3xl md:text-4 lg:text-5xl text-center lg:text-left mb-6 font-bold capitalize'>A Simple Real Estate management Mobile app</h2>
                        <p className='text-grey text-lg text-center lg:text-left mb-6 capitalize'>
                            download, upload and manage your real estate assets in one app. try it now for free.
                        </p>
                        <div className='flex justify-center flex-wrap gap-6'>
                            {/* <button type='button' className='btn btn-primary hover:bg-white hover:text-black'>Get it on play store</button> */}
                            <GoogleButton />
                            <AppleButton />
                            {/* <button type='button' className='btn btn-white hover:bg-primary hover:text-white'>Get it on app store</button> */}
                        </div>
                    </div>

                    {/* Image */}
                    <div className='flex justify-center flex-1 mb-10 md:mb-16 lg:mb-0 z-10'>
                        <img src={image2} alt="Logo" className="rounded-md w-3/5 h-3/5" />
                    </div>
                </div>
                <div className='hidden md:block overflow-hidden bg-primary rounded-l-full absolute h-80 w-2/4 top-52 lg: -bottom-28 lg: -right-26 right-0'>
                </div>
            </section>

            {/* Features */}
            <section ref={feature} className='bg-app-white py-20 mt-20 lg:mt-40'>
                {/* Heading */}
                <div className='sm:w-3/4 lg:w-5/12 mx-auto px-2'>
                    <h1 className='text-3xl text-center text-primary capitalize font-bold'>features</h1>
                    <p className='text-center text-grey mt-4'>
                        <span className='font-bold italic text-lg text-primary'>owaa app</span> allows real estate owners and managers to track, manage and communicate the performance of their real estate assets. Owaa allows you to manage your properties; the occupants in those properties and their associated financial transactions, while also keeping you updated on rent payment.
                    </p>
                </div>

                {/* Feature 1 */}
                <div class="relative mt-20 lg:mt-24">
                    <div class="container flex flex-col lg:flex-row items-center justify-center gap-x-24">
                        {/* Image   */}
                        <div class="flex flex-1 justify-center z-10 mb-10 lg:mb-0">
                            <img
                                className="rounded-md w-3/5 h-3/5"
                                src={Pic2}
                                alt=""
                            />
                        </div>
                        {/* Content  */}
                        <div class="flex flex-1 flex-col items-center lg:items-start">
                            <h1 class="text-3xl text-bookmark-blue text-center lg:text-left capitalize font-bold">manage your properties</h1>
                            <p class="text-bookmark-grey my-4 text-center lg:text-left sm:w-3/4 lg:w-full">
                                add, delete and keep track of all your properties. Get insights such as number of occupants in a property, number of occupied and vacant spaces in that property. <br />assign an occupant to a property with all the necessary information required.
                            </p>
                            <button type="button" class="btn btn-primary hover:bg-white hover:text-black">Get started</button>
                        </div>
                    </div>
                    {/* Rounded Rectangle  */}
                    <div className='hidden lg:block overflow-hidden bg-primary rounded-r-full absolute h-80 w-2/4 top-44 -bottom-24 -left-26'>
                    </div>
                </div>

                {/* Feature 2 */}
                <div class=" bg-white relative mt-20 lg:mt-52 py-20">
                    <div class="container flex flex-col lg:flex-row-reverse items-center justify-center gap-x-24">
                        {/* Image   */}
                        <div class="flex flex-1 justify-center z-10 mb-10 lg:mb-0">
                            <img
                                className="rounded-md w-3/5 h-3/5"
                                src={owaa5}
                                alt=""
                            />
                        </div>
                        {/* Content  */}
                        <div class="flex flex-1 flex-col items-center lg:items-start">
                            <h1 class="text-3xl text-bookmark-blue text-center lg:text-left capitalize font-bold">keep track of your occupants</h1>
                            <p class="text-bookmark-grey my-4 text-center lg:text-left sm:w-3/4 lg:w-full">
                                manage occupants in your various properties with our unique occupant management solution. <br />assign an occupant to a property and get insights such as when rent is due, bills payment, which property he/she is occupying etc.
                            </p>
                            <button type="button" class="btn btn-primary hover:bg-white hover:text-black">Get started</button>
                        </div>
                    </div>
                    {/* Rounded Rectangle  */}
                    <div className='hidden md:block overflow-hidden bg-primary rounded-l-full absolute h-80 w-2/4 top-44 lg: -bottom-28 lg: -right-26 right-0'>
                    </div>
                </div>

                {/* Feature 3 */}
                <div class="relative mt-20 lg:mt-24">
                    <div class="container flex flex-col lg:flex-row items-center justify-center gap-x-24">
                        {/* Image   */}
                        <div class="flex flex-1 justify-center z-10 mb-10 lg:mb-0">
                            <img
                                className="rounded-md w-3/5 h-3/5"
                                src={Pic1}
                                alt=""
                            />
                        </div>
                        {/* Content  */}
                        <div class="flex flex-1 flex-col items-center lg:items-start">
                            <h1 class="text-3xl text-bookmark-blue text-center lg:text-left capitalize font-bold">track transactions and activities</h1>
                            <p class="text-bookmark-grey my-4 text-center lg:text-left sm:w-3/4 lg:w-full">
                                consolidate, analyze and download(in pdf format) all the transactions around your properties, including transactional activities of each occupant and get insights into the performance of each property and occupant.
                            </p>
                            <button type="button" class="btn btn-primary hover:bg-white hover:text-black">Get started</button>
                        </div>
                    </div>
                    {/* Rounded Rectangle  */}
                    <div className='hidden lg:block overflow-hidden bg-primary rounded-r-full absolute h-80 w-2/4 top-44 -bottom-24 -left-26'>
                    </div>
                </div>
            </section>

            {/* Contact Us */}
            <section class="bg-primary text-white py-20">
                <div class="container">
                    <div class="sm:w-3/4 lg:w-2/4 mx-auto">
                        {/* <p class="font-light uppercase text-center mb-8">35,000+ ALREADY JOINED</p> */}
                        <h1 class="text-3xl text-center capitalize">stay up-to-date with what we’re doing</h1>
                        <div class="flex flex-col sm:flex-row gap-6 mt-8">
                            <input
                                type="text"
                                placeholder="enter your email address"
                                class="focus:outline-none flex-1 px-2 py-3 rounded-md text-black"
                            />
                            <button type="button" class="btn bg-secondary hover:bg-white hover:text-black">
                                contact us
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* footer */}
            <Footer />
        </body >
    );
}

export default Home;
